import styled from "styled-components";
import { breakpoints } from "../../globalStyles";

export const TrackList = styled.ul`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TrackSkeleton = styled.span`
  height: 88px;

  @media ${breakpoints.sm} {
    height: 48px;
  }
`;
